exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".quickstats-d25b47bb{width:clamp(470px, 50%, 700px)}.participantsTable-eec6c4c3{width:100%;border-collapse:collapse}.participantsTable-eec6c4c3 thead{background-color:#eee}.participantsTable-eec6c4c3 th{font-weight:500;font-size:14px;line-height:20px;padding:10px 20px;text-align:left}.participantsTable-eec6c4c3 td{border:1px solid #e0e0e0;padding:10px 20px}.participantsTable-eec6c4c3 tr.strikethrough-27732959 td{text-decoration:line-through}\n", ""]);

// Exports
exports.locals = {
	"quickstats": "quickstats-d25b47bb",
	"participantsTable": "participantsTable-eec6c4c3",
	"strikethrough": "strikethrough-27732959"
};